module.exports = __webpack_public_path__ + "img/3.93c93084.png";